import React, { useLayoutEffect, useRef } from 'react'
import styled from 'styled-components'
import { shareScreenStore } from '../useTwilio'

// Took this from here
// https://github.com/twilio/twilio-video.js/blob/146453a512e60da465b6bb10db49eda20cbf686a/lib/media/track/mediatrack.js
const attach = (el, stream) => {
    stream.addTrack(stream.getVideoTracks()[0])
    el.srcObject = stream
    el.autoplay = true
    el.playsInline = true
}

const S = {
    Video: styled.video`
        width: 100%;
        object-fit: contain;
        height: 100%;
        object-position: 50% 50%;
        overflow: hidden;
        background: black;
    `,
}

const MyScreen = () => {
    const videoRef = useRef()
    const isSet = useRef(false)

    useLayoutEffect(() => {
        const handler = setInterval(() => {
            if (shareScreenStore.stream && videoRef?.current && !isSet.current) {
                attach(videoRef.current, shareScreenStore.stream)
                isSet.current = true
                clearInterval(handler)
            }
        }, 333)
    }, [videoRef, isSet])

    return <S.Video ref={videoRef} autoPlay />
}

export default MyScreen
